import { TypographyP } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

const NoTeamMembersOverlay = () => {
    return (
        <div className="flex h-full w-full items-center justify-center">
            <TypographyP>{UIStrings.NoTeamMembersFound}</TypographyP>
        </div>
    );
};

export default NoTeamMembersOverlay;
